import { Grid } from '@mui/material';
import { ArrowBack as ArrowBackIcon } from '@mui/icons-material';
import { grey } from '@mui/material/colors';
import { makeStyles } from 'tss-react/mui';

import IconButton from '../buttons/Icon';

const useStyles = makeStyles()((theme) => ({
  root: {
    marginBottom: theme.spacing(2),
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'auto 2fr',
  },
  backButton: {
    padding: '4px 12px',
  },
  backArrowBox: {
    gridColumn: '1 / 2',
    alignItems: 'flex-start',
  },
  stepName: {
    color: grey[700],
  },
  stepsInfo: {
    gridColumn: '2 / 3',
    width: 'auto',
    flexDirection: 'column',
    marginTop: theme.spacing(1/2),
  },
  selectedStepResult: {
    flexDirection: 'column',
    width: 'auto',
  },
  dateTimeDivider: {
    [theme.breakpoints.up('sm')]: {
      display: 'none',
    },
  },
}));

const Navigation = (props) => {
  const {
    bookingFlow,
    stepsData,
    currentStep,
    handlePrevStep,
    classes: parentClasses,
  } = props;

  let prevStep = bookingFlow.getPrevVisibleStep(currentStep, stepsData);
  if (!prevStep) {
    prevStep = bookingFlow.getPrevStep(currentStep, stepsData);
  }
  const prevStepData = prevStep.getData(stepsData);

  const {classes, cx} = useStyles();

  return (
    <nav className={cx(parentClasses.mapOrNavigationBox, classes.root)}>
      <div className={classes.grid}>
        <Grid container className={classes.backArrowBox}>
          <IconButton
            onClick={handlePrevStep}
            disabled={prevStepData.isHidden}
            className={classes.backButton}
          >
            <ArrowBackIcon color={prevStepData.isHidden ? 'disabled' : 'primary'} />
          </IconButton>
        </Grid>
        <Grid container className={classes.stepsInfo}>
          <Grid item className={classes.stepName}>{prevStep.title}</Grid>
          <Grid container className={classes.selectedStepResult}>
            {stepsData.location.name && <Grid item>{stepsData.location.name}</Grid>}
            {stepsData.service.name && (
              <Grid container>
                <Grid item>{stepsData.service.name}</Grid>
                {stepsData.staff.name && <Grid item>&nbsp;with {stepsData.staff.name}</Grid>}
              </Grid>
            )}
            {stepsData.datetime.formattedDate && (
              <Grid container>
                <Grid item>{stepsData.datetime.formattedDate}</Grid>
                &nbsp;
                <Grid item className={classes.dateTimeDivider}>@&nbsp;</Grid>
                <Grid item>
                  {stepsData.datetime.formattedStartTime}
                  &nbsp;&mdash;&nbsp;
                  {stepsData.datetime.formattedStopTime}
                </Grid>
              </Grid>
            )}
          </Grid>
        </Grid>
      </div>
    </nav>
  );
};

export default Navigation;
